import Accounts from "../accounts/Accounts";
import CreateAccountForm from "../accounts/CreateAccountForm";
import UpdateAccountForm from "../accounts/UpdateAccountForm";
import ManageAccountNumberForm from "../accounts/ManageAccountNumberForm";
import ManageAccountNumbers from "../accounts/manageAccountNumbers";
import ViewAccountForm from "../accounts/ViewAccountForm";
import CallFlowsTable from "../files/CallFlowsTable";
import PromptsTable from "../files/PromptsTable";
import OneStepCallFlow from "../files/OneStepCallFlow";
import CreateGroupAccount from "../groupAccounts/CreateGroupAccount";
import GroupAccounts from "../groupAccounts/GroupAccounts";
import UpdateGroupAccount from "../groupAccounts/UpdateGroupAccount";
import ViewGroup from "../groupAccounts/ViewGroup";
import SystemConfig from "../systemConfig/SystemConfig";
import ChangePassword from "../user/ChangePassword";
import CreateUserForm from "../user/CreateUserForm";
import UpdateUserForm from "../user/UpdateUserForm";
import Users from "../user/Users";
import ViewUserForm from "../user/ViewUserForm";
import UnauthorizedPage from "./UnauthorizedPage";
import ParentDashboard from "../dashboards/ParentDashboard";
import CreateAccountAdminForm from "../user/CreateAccountAdminForm";
import CreateSuperUsers from "../user/CreateSuperUsers";
import Profile from "../user/Profile";
import PackageTable from "../package/PackagesTable";
import CreatePackage from "../package/CreatePackage";
import UpdatePackage from "../package/UpdatePackage";
import AccountMSISDNTable from "../accountMSISDN/AccountMSISDNTable";
import CreateAccountMSISDN from "../accountMSISDN/CreateAccountMSISDN";
import AgentChangeState from "../Reports/agentChangeState";
import CreateCallFlow from "../callFlowCreation/CreateCallFlow";
import { AccordionSummary } from "@material-ui/core";
import AccountSummary from "../AccountSummary/AccountSummary";
import customer from "../customers/customer";
import createCustomerForm from "../customers/createCustomerForm";
import CreateTicketCategoryForm from "../ticketCategories/CreateTicketCategoryForm";
import TicketCategories from "../ticketCategories/TicketCategories";
import Tickets from "../Tickets/Tickets";
import CreateTicketsForm from "../Tickets/CreateTicketsForm";
import ViewTicketDetails from "../Tickets/ViewTicketDetails";
import BackupAndRestore from "../backupAndRestore/BackupAndRestore";
import { Treemap } from "recharts";
import TreePrime from "../Tree/TreePrime";
import ListLiveCalls from "../liveCall/ListLiveCalls";
import AllCdrs from "../cdr/AllCdrs";
import CDRTableComponent from "../cdr/CDRTableComponent";
import CDRTable from "../cdr/CDRTable";
import ListInvitations from "../invitations/ListInvitations";

export const routes = [
  {
    name: "Dashboard",
    icon: "dashboard",
    access: true,
    subRoutes: [
      {
        name: "Dashboard",
        key: "dashboard",
        access: true,
        component: ParentDashboard,
      },
    ],
  },
  {
    name: "Accounts",
    icon: "apartment",
    subRoutes: [
      {
        name: "View Accounts",
        key: "accounts",
        privileges: ["LIST.ACCOUNTS"],
        component: Accounts,
      },
    ],
  },
  {

    name: "010Hotline Numbers",
    icon: "apartment",
    subRoutes: [{
      name: "010Hotline Numbers",

      key: "accountMsisdn",

      privileges: ["LIST.BIVR.NUMBERS"],
      component: AccountMSISDNTable,
    }
    ]
  },
  {
    name: "System Properties",
    icon: "control",
    subRoutes: [
      {
        name: "View System Properties",
        key: "system",
        privileges: ["MANAGE.SYSTEM.CFG"],
        component: SystemConfig,
      },
      // {
      //   name: "Packages",
      //   key: "packages",
      //   privileges: ["LIST.PACKAGES"],
      //   component: PackageTable,
      // },
    ],
  },
  {
    name: "Users",
    icon: "user",
    subRoutes: [
      {
        name: "View Users",
        key: "users",
        component: Users,
        privileges: ["LIST.USERS"],
      },
      {
        name: "Create User",
        key: "users/create",
        component: CreateUserForm,
        privileges: ["CREATE.USER"],
      },
      {
        name: "Create Users",
        key: "user/create",
        component: CreateSuperUsers,
        privileges: ["CREATE.SUPER.USERS"],
      },
       {
        name: "View Invitations",
        key: "users/invitations",
        component: ListInvitations,
        privileges: ["LIST.INVITATIONS"],
      },
    ],
  },
  {
    name: "Groups",
    icon: "team",
    subRoutes: [
      {
        name: "View Groups",
        key: "groups/",
        privileges: ["LIST.GROUPS"],
        component: GroupAccounts,
      },
      {
        name: "Create Group",
        key: "groups/create",
        component: CreateGroupAccount,
        privileges: ["CREATE.GROUP"],
      },
    ],
  },
  {
    name: "Cdrs",
    icon: "phone",
    subRoutes: [
      {
        name: "Cdrs",
        key: "cdrs",
        component: CDRTableComponent,
        privileges: ["LIST.CDRS"],
      },
      {
        name: "Cdrs",
        key: "allcdrs",
        component: AllCdrs,
        privileges: ["LIST.ALL.CDRS"],
      },
      {
        name: "Live Calls",
        key: "liveCalls",
        component: ListLiveCalls,
        privileges: ["LIST.LIVE.CALLS"],
      },
    ],
  },
  {
    name: "CRM",
    icon: "customer-service",
    subRoutes: [
      {
        name: "Manage Customers",
        key: "customers",
        component: customer,
        privileges: ["LIST.CUSTOMER"],
      },
      // {
      //   name: "Create Customer",
      //   key: "customer/create",
      //   component: createCustomerForm,
      //   privileges: ["CREATE.CUSTOMER"],
      // },
      {
        name: "Manage Tickets",
        key: "tickets",
        component: Tickets,
        privileges: ["LIST.TICKET"],
      },
      // {
      //   name: "Create Ticket",
      //   key: "ticket/create",
      //   component: CreateTicketsForm,
      //   privileges: ["CREATE.TICKET"],
      // },
      {
        name: "Manage Ticket Categories",
        key: "ticketCategories",
        component: TicketCategories,
        privileges: ["VIEW_TICKET_CATEGORY"],
      },
      // {
      //   name: "Create Ticket Category",
      //   key: "ticketCategories/create",
      //   component: CreateTicketCategoryForm,
      //   privileges: ["CREATE_TICKET_CATEGORY"],
      // },
    ],
  },
  // {
  //   name: "Tickets",
  //   icon: "solution",
  //   subRoutes: [
  //     {
  //       name: "View Tickets",
  //       key: "tickets",
  //       component: Tickets,
  //       privileges: ["LIST.TICKET"],
  //     },
  //     {
  //       name: "Create Ticket",
  //       key: "ticket/create",
  //       component: CreateTicketsForm,
  //       privileges: ["CREATE.TICKET"],
  //     },
  //   ],
  // },
  // {
  //   name: "Tikcet Categories",
  //   icon: "cluster",
  //   subRoutes: [
  //     {
  //       name: "Manage Ticket Categories",
  //       key: "ticketCategories",
  //       component: TicketCategories,
  //       privileges: ["LIST_TICKET_CATEGORY"],
  //     },
  //     {
  //       name: "Create Ticket Category",
  //       key: "ticketCategories/create",
  //       component: CreateTicketCategoryForm,
  //       privileges: ["CREATE_TICKET_CATEGORY"],
  //     },
  //   ],
  // },
  {
    name: "Configurations",
    icon: "setting",
    subRoutes: [
      // {
      //   name: "One Step Call flow",
      //   key: "configuration/oneStepCallFlow",
      //   component: OneStepCallFlow, //change to the new created component
      //   privileges: ["LIST.PROMPTS"], //change to the new created privilege
      // },
      {
        name: "Call flows",
        key: "configuration/callFlow",
        component: CallFlowsTable, //change to the new created component
        privileges: ["LIST.CALLFLOWS", "EDIT.DEVELOPED.CALLFLOW"], //change to the new created privilege
      },
      {
        name: "Prompts",
        key: "configuration/prompts",
        component: PromptsTable,
        privileges: ["LIST.PROMPTS"],
      },
      // {
      //   name: "Create Call Flow",
      //   key: "configuration/createCallFlow",
      //   component: CreateCallFlow,
      //   privileges: ["UPLOAD.DEVELOPED.CALLFLOW"],
      // },
    ],
  },
  {
    name: "Reports",
    icon: "table",
    subRoutes: [
      {
        name: "Agent Change Status",
        key: "agentChangeStatusReport",
        component: AgentChangeState,
        privileges: ["GET.AGENT.CHANGE.STATUSA", "GET.AGENT.CHANGE.STATUSU"],
      },
    ],
  },
  {
    name: "Account Summary",
    icon: "audit",
    subRoutes: [
      {
        name: "Account Summary",
        key: "accountSummary",
        component: AccountSummary,
        privileges: ["ACCOUNT_SUMMARY"],
      },
    ],
  },
  {
    name: "Backup And Restore",
    icon: "hdd",
    subRoutes: [
      {
        name: "Backup And Restore",
        key: "backupAndRestore",
        component: BackupAndRestore,
        privileges: ["LIST.PROMPTS"],
      },
    ],
  },
  // {
  //   name: "Live Call",
  //   icon: "phone",
  //   subRoutes: [
  //     {
  //       name: "LiveCalls",
  //       key: "liveCalls",
  //       component: ListLiveCalls,
  //       privileges: ["LIST.LIVE.CALLS"],
  //     },
  //   ],
  // },
];

export const nonSubmenuRoutes = [
  {
    key: "unauthorized",
    component: UnauthorizedPage,
    access: true,
  },
  {
    key: "profile",
    component: Profile,
    access: true,
  },
  {
    key: "changePassword",
    component: ChangePassword,
    access: true,
  },
  {
    key: "accounts/view/:id",
    component: ViewAccountForm,
    privileges: ["LIST.ACCOUNTS"],
  },
  {
    key: "accounts/users/:id",
    component: Users,
    privileges: ["LIST.ACCOUNTS"],
  },

  {
    key: "accounts/edit/:id",
    component: UpdateAccountForm,
    privileges: ["UPDATE.ACCOUNT"],
  },
  {
    key: "accounts/addAccountNumbers/:id",
    component: ManageAccountNumberForm,
    privileges: ["MANAGE.ACCOUNT.NUMBERS", "ADD.BIVR.NUMBERS"],
  },
  {
    key: "accounts/manageAccountNumbers/:id",
    // component: ManageAccountNumberForm,
    component: ManageAccountNumbers,
    privileges: ["MANAGE.ACCOUNT.NUMBERS", "DELETE.BIVR.NUMBER"],
  },

  {
    key: "accounts/admin/create/:id",
    component: CreateAccountAdminForm,
    privileges: ["CREATE.ACCOUNT.ADMIN"],
  },
  {
    key: "groups/view/:id",
    component: ViewGroup,
    privileges: ["LIST.GROUPS"],
  },
  {
    key: "groups/edit/:id",
    component: UpdateGroupAccount,
    privileges: ["UPDATE.GROUP"],
  },
  {
    key: "users/view/:id",
    component: ViewUserForm,
    privileges: ["LIST.USERS"],
  },
  {
    key: "users/edit/:id",
    component: UpdateUserForm,
    privileges: ["UPDATE.USER"],
  },
  {
    key: "accounts/create",
    component: CreateAccountForm,
    privileges: ["CREATE.ACCOUNT"],
  },
  {
    key: "packages/create",
    component: CreatePackage,
    privileges: ["CREATE.PACKAGE"],
  },
  {
    key: "packages/edit/:pkgCode/:pkgName",
    component: UpdatePackage,
    privileges: ["UPDATE.PACKAGE"],
  },
  {
    key: "accounts/createAccountMSISDN",
    component: CreateAccountMSISDN,
    privileges: ["CREATE.ACCOUNT"],
  },
  {
    key: "ticket/view/:id",
    component: ViewTicketDetails,
    privileges: ["LIST.TICKET"],
  },
  {
    name: "Create Ticket Category",
    key: "ticketCategories/create",
    component: CreateTicketCategoryForm,
    privileges: ["CREATE_TICKET_CATEGORY"],
  },
  {
    name: "Create Ticket",
    key: "ticket/create",
    component: CreateTicketsForm,
    privileges: ["CREATE.TICKET"],
  },
  {
    name: "Create Customer",
    key: "customer/create",
    component: createCustomerForm,
    privileges: ["CREATE.CUSTOMER"],
  },
  {
    name: "Create Call Flow",
    key: "configuration/createCallFlow",
    component: CreateCallFlow,
    privileges: ["UPLOAD.DEVELOPED.CALLFLOW"],
  },
];
